/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartmanual3Inputs */

const en_eventaistartmanual3 = /** @type {(inputs: Eventaistartmanual3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in yourself instead`)
};

const de_eventaistartmanual3 = /** @type {(inputs: Eventaistartmanual3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieber selbst ausfüllen`)
};

/**
* | output |
* | --- |
* | "Fill in yourself instead" |
*
* @param {Eventaistartmanual3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartmanual3 = /** @type {((inputs?: Eventaistartmanual3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartmanual3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartmanual3(inputs)
	return de_eventaistartmanual3(inputs)
});
export { eventaistartmanual3 as "eventAiStartManual" }